import { createSelector } from '@reduxjs/toolkit';
import { selectTotalArea } from 'shared/selectors/jsonQuery';

export const selectSuburbanAreaDailyRentFilter = createSelector(selectTotalArea, ({ gte = null, lte = null }) => ({
  label: 'Площадь дома',
  valueMin: gte,
  valueMax: lte,
  min: 1,
  max: 99999,
}));
